//import { combineReducers } from 'redux'

import { ActionT } from '../actions/actionsType'
import {
    TELEPHONY_START,
    TELEPHONY_Close,
    SET_TWILIO_TOKEN,
    TELEPHONY_INCOMING,

} from '../actions/twilioActions'

export interface TelephonyStateT {
    clientName: string
    twilioToken: string
    isOpen: boolean
    params?: any
}
const telephonyInitialState: TelephonyStateT = {
    clientName: 'jenny',
    twilioToken: '',
    isOpen: false,
    params: null,
}


export function telephonyState(state: TelephonyStateT = telephonyInitialState, action: ActionT): TelephonyStateT {

    switch (action.type) {
        case SET_TWILIO_TOKEN:
            return Object.assign({}, state, {
                twilioToken: action.payload.twilioToken,
            })
        case TELEPHONY_START:
            return Object.assign({}, state, {
                isOpen: true,
                params: action.payload.params

            })
        case TELEPHONY_INCOMING:
            return Object.assign({}, state, {
                isOpen: true,
            })
        case TELEPHONY_Close:
            return Object.assign({}, state, {
                isOpen: false,
                params: null,
            })
        default:
            return state
    }
}
export default telephonyState;
